import { render, staticRenderFns } from "./phoneNumber.vue?vue&type=template&id=ace0af68&scoped=true"
import script from "./phoneNumber.vue?vue&type=script&lang=ts"
export * from "./phoneNumber.vue?vue&type=script&lang=ts"
import style0 from "./phoneNumber.vue?vue&type=style&index=0&id=ace0af68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace0af68",
  null
  
)

export default component.exports